// extracted by mini-css-extract-plugin
export var alertIcon = "_n7-0";